import assign from 'lodash/assign'
import { Message } from 'element-ui'

let NewMessage = function (options) {
  if (typeof options === 'string') options = {message: options}
  if (!options.iconClass) {
    options.iconClass = message_type[options.type] || message_type.info
  }
  return Message(options)
}

assign(NewMessage, Message)

NewMessage.prototype = Message.prototype

let message_type = {
  success: 'el-icon-success message-icon text-primary',
  warning: 'el-icon-warning message-icon text-warning',
  info: '',
  error: 'el-icon-error message-icon text-danger',
}

Object.keys(message_type).forEach(type => {
  NewMessage[type] = options => {
    if (typeof options === 'string') options = {message: options}
    options.iconClass = message_type[type] || ''
    return Message(options)
  }
})

export default NewMessage



// WEBPACK FOOTER //
// ./src/common/message.js